import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const STATUS_LABEL = {
  occupied: "Occupied",
  vacant: "Vacant",
  maintenance: "Maintenance",
  needs_cleaning: "Needs Cleaning",
  management: "Management / Internal",
};

const customerName = (u) => {
  const full = `${u.first_name || ""} ${u.surname || ""}`.trim();
  return full || u.tenant_name || "";
};

const nameCell = (u) => {
  if (u.status === "occupied") return customerName(u) || "—";
  return STATUS_LABEL[u.status] || u.status || "—";
};

const BRAND = "King Country Self Storage";
const NAVY = [15, 23, 42];
const BLUE = [37, 99, 235];

// groups: [{ name: "Otorohanga", units: [...all units for site, sorted] }]
export function downloadCustomerList({ fileLabel, groups }) {
  const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const generated = new Date().toLocaleString("en-NZ", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });

  groups.forEach((group, gi) => {
    if (gi > 0) doc.addPage();

    // Branded header band
    doc.setFillColor(...NAVY);
    doc.rect(0, 0, pageWidth, 70, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text(BRAND, 40, 32);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.setTextColor(191, 219, 254);
    doc.text("Site Shed Directory", 40, 50);

    // Site + meta line
    const occupied = group.units.filter((u) => u.status === "occupied").length;
    doc.setTextColor(...NAVY);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(group.name, 40, 100);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(100, 116, 139);
    doc.text(`${group.units.length} sheds · ${occupied} occupied`, 40, 116);
    doc.text(`Generated ${generated}`, pageWidth - 40, 116, { align: "right" });

    const rows = group.units.map((u) => [
      u.unit_number,
      STATUS_LABEL[u.status] || u.status || "—",
      nameCell(u),
      u.phone || "—",
    ]);

    autoTable(doc, {
      startY: 128,
      head: [["Shed / Unit", "Status", "Customer Name", "Phone"]],
      body: rows.length ? rows : [["—", "—", "No sheds", "—"]],
      margin: { left: 40, right: 40 },
      styles: { fontSize: 10, cellPadding: 6, lineColor: [226, 232, 240], lineWidth: 0.5 },
      headStyles: { fillColor: BLUE, textColor: 255, fontStyle: "bold" },
      alternateRowStyles: { fillColor: [248, 250, 252] },
      columnStyles: {
        0: { cellWidth: 90, fontStyle: "bold" },
        1: { cellWidth: 110 },
        3: { cellWidth: 100 },
      },
      didDrawPage: () => {
        const h = doc.internal.pageSize.getHeight();
        doc.setFontSize(8);
        doc.setTextColor(148, 163, 184);
        doc.text(BRAND, 40, h - 20);
        doc.text(`Page ${doc.internal.getNumberOfPages()}`, pageWidth - 40, h - 20, { align: "right" });
      },
    });
  });

  const stamp = new Date().toISOString().slice(0, 10);
  doc.save(`KCSS-Shed-Directory-${fileLabel}-${stamp}.pdf`);
}
